export default __webpack_public_path__ + "static/media/WOR-interview1.e77beacf.png";